import React from "react";
import SprTemplateNaznMain from "./spr-template-nazn-main";
import SprTemplateNaznSostav from "./spr-template-nazn-sostav";

export const TEMPLATE_NAZN_TAB_KEYS = {
  MAIN: "main",
  SOSTAV: "sostav"
};

export const TEMPLATE_NAZN_TAB_ITEMS = [
  { key: TEMPLATE_NAZN_TAB_KEYS.MAIN, label: "Основная" },
  { key: TEMPLATE_NAZN_TAB_KEYS.SOSTAV, label: "Состав" }
];

/**
 * Карточка шаблона: контент активной вкладки.
 */
const SprTemplateNaznCard = ({
  idShb,
  isNew = false,
  open,
  activeTab,
  canEdit,
  onSaved,
  onCancel
}) => {
  if (isNew || activeTab === TEMPLATE_NAZN_TAB_KEYS.MAIN) {
    return (
      <SprTemplateNaznMain
        idShb={idShb}
        isNew={isNew}
        open={open}
        canEdit={canEdit}
        onSaved={onSaved}
        onCancel={onCancel}
      />
    );
  }

  return <SprTemplateNaznSostav idShb={idShb} open={open} canEdit={canEdit} />;
};

export default SprTemplateNaznCard;
